import http from "./http";

class TypespublicationsService {
    
    index(token){
        return http.get("/api/typepublications",{ headers: { 'Authorization': 'Bearer '+token } })
    }

    store(data,token){
        return http.post("/api/typepublications/store", data,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    edit(id,token){
        return http.get(`/api/typepublications/${id}/edit`,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    update(id, data,token){
        return http.post(`/api/typepublications/${id}/update`, data,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    delete(id,token){
        return http.delete(`/api/typepublications/${id}/delete`,{ headers: { 'Authorization': 'Bearer '+token } })
    }

}

export default new TypespublicationsService()